import { usingPost } from '@ocean/api'

export const trySimulatorExerciseSession = (exerciseId: Guid) =>
  usingPost(`SimulatorTrainings/TrySimulatorExerciseSession`, { exerciseId })

export const stopSimulatorExerciseSession = (sessionId: Guid) =>
  usingPost(`SimulatorTrainings/StopSimulatorExerciseSession`, { sessionId })
